import formFeedback from './form-feedback';

new formFeedback();


// WEBPACK FOOTER //
// ./_src/js/index.js